module.exports = __webpack_public_path__ + "static/media/email-image.774f1496.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/email-image.svg
// module id = 422
// module chunks = 0